import React from 'react';
import Type from 'prop-types';
import { Grid } from "@mui/material";
import HorizontalScroll from '../HorizontalScroll';

const FilterChips = (props) => {
  const { singleLine, children } = props;

  if (singleLine) {
    return (
      <HorizontalScroll>
        <Grid alignItems="center" wrap={singleLine ? 'nowrap' : 'wrap'} container>
          {children}
        </Grid>
      </HorizontalScroll>
    );
  }

  return (
    <Grid alignItems="center" container>
      {children}
    </Grid>
  );
};

FilterChips.propTypes = {
  singleLine: Type.bool,
  children: Type.node.isRequired,
};

FilterChips.defaultProps = {
  singleLine: false,
};

export default FilterChips;
